import Glyph from 'reactGarden/Glyph'

import { Tab, Tabs, TabList, TabPanel, ProductLink } from './styled'

const TabsInfo = ({ description, rules, productLink }) => (
  <Tabs>
    <TabList>
      {description && <Tab selectedClassName="selected">Descrição</Tab>}
      {rules && <Tab selectedClassName="selected">Regulamento</Tab>}
    </TabList>

    {description && (
      <TabPanel selectedClassName="selected">
        <span>{description}</span>
        {productLink && (
          <ProductLink href={productLink}>
            Veja a página do produto <Glyph glyph="arrow" direction="right" />
          </ProductLink>
        )}
      </TabPanel>
    )}

    {rules && (
      <TabPanel selectedClassName="selected">
        <span>{rules}</span>
      </TabPanel>
    )}
  </Tabs>
)

export default TabsInfo
